import { cloneDeep } from "lodash";
import routerTile from "./routerTile";
import classroomUsage from "./modules/classroomUsage";
import classroomQuery from "./modules/classroomQuery";
import classroomMap from "./modules/classroomMap";
import check from "./modules/check";

const Maps = [
  // {
  //   path: "/workplace",
  //   name: "workplace",
  //   redirect: "/workplace/Index",
  //   children: [
  //     {
  //       path: "/workplace/Index",
  //       name: "Index",
  //       component: () =>
  //         import(/* webpackChunkName: "index" */ "@/views/workplace/Index.vue"),
  //       meta: {
  //         title: "工作台",
  //         icon: "wap-home-o",
  //         showMainMenu: false
  //       }
  //     }
  //   ]
  // },
  {
    path: "/blank",
    name: "Blank",
    component: () =>
      import(/* webpackChunkName: "index" */ "@/views/Blank.vue"),
    meta: {
      title: "",
    },
  },
];
const modulesMap = routerTile(
  cloneDeep(Maps.concat(classroomUsage, classroomQuery, classroomMap, check))
);

export const asyncRoutes = [
  {
    path: "/",
    name: "BasicLayout",
    component: () =>
      import(/* webpackChunkName: "index" */ "@/layouts/BasicLayout.vue"),
    meta: { title: "首页" },
    redirect: "/classroomUsage",
    children: modulesMap,
  },
  {
    path: "/check/List",
    name: "checkList",
    component: () =>
      import(/* webpackChunkName: "index" */ "@/views/check/List.vue"),
    meta: { title: "申请审批" },
    redirect: "/checkList",
  },
  {
    path: "/check/Detail",
    name: "checkDetail",
    component: () =>
      import(/* webpackChunkName: "index" */ "@/views/check/Detail.vue"),
    meta: { title: "详情" },
    redirect: "/checkDetail",
  },

  {
    path: "*",
    name: "404",
    component: () => import(/* webpackChunkName: "index" */ "@/views/404.vue"),
    meta: { title: "404" },
  },
  {
    path: "/notInDingTalk",
    name: "notInDingTalk",
    component: () =>
      import(/* webpackChunkName: "index" */ "@/views/notInDingTalk.vue"),
    meta: { title: "notInDingTalk" },
  },
  {
    path: "/noPermissions",
    name: "noPermissions",
    component: () =>
      import(/* webpackChunkName: "index" */ "@/views/noPermissions.vue"),
    meta: { title: "noPermissions" },
  },
];

export const constantRoutes = [];
